import Axios from "./config";

class Tags {
  /**
   *
   */
  getTags() {
    return Axios.get("/tags");
  }

  /**
   *
   * @param {*} formData
   */
  manageTag(formData) {
    if (!formData.id) {
      return Axios.post("/tags", formData);
    }

    return Axios.put("/tags", formData);
  }

  /**
   *
   * @param {*} id
   */
  deleteTag(id) {
    return Axios.delete(`/tags/${id}`);
  }
}

export default new Tags();



// WEBPACK FOOTER //
// ./src/api/tags.js